export default __webpack_public_path__ + "static/media/hacker-icon.f4cd27ef.svg";